import { Device, Service } from '@mi-front/core';
import { AsyncView, Title } from '@mi-front/ui';
import { Button } from '@mui/material';
import { apiClient } from '../../../../../api';
import { SimpleTable } from '../../../../../components/base/SimpleTable';
import { ServiceConfig } from './actions/ServiceConfig';
import { ServiceRestart } from './actions/ServiceRestart';
import { ServiceStart } from './actions/ServiceStart';
import { ServiceStop } from './actions/ServiceStop';
import { ServiceStatus } from './Status';

import { FormattedMessage } from 'react-intl';
interface Props {
  readonly data: {
    readonly device: Device;
    readonly services: readonly Service[];
  };
  readonly reload: () => any;
}

export function ServicesListP(p: Props) {
  const { data, reload } = p;
  const { device, services } = data;

  return (
    <div className="mt-4">
      <Title className="mb-3 font-size-base">
        <FormattedMessage id="streamerBox.props.services" defaultMessage="Servicios" />
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          sx={{ marginLeft: 1.5 }}
          onClick={reload}
        >
          <FormattedMessage id="common.refresh" defaultMessage="Actualizar" />
        </Button>
      </Title>
      <SimpleTable
        headers={[
          <FormattedMessage
            key="service"
            id="streamerBox.props.service"
            defaultMessage="Servicio"
          />,
          <FormattedMessage key="status" id="streamerBox.props.status" defaultMessage="Estado" />,
          <FormattedMessage key="actions" id="common.text.actions" defaultMessage="Acciones" />,
        ]}
        rows={services.map((service) => [
          service.baseService.name,
          <ServiceStatus key={service.id} service={service} />,
          <div key={`actions-${service.id}`} style={{ display: 'flex', gap: '0.5rem' }}>
            <ServiceStart device={device} service={service} />
            <ServiceRestart device={device} service={service} />
            <ServiceStop device={device} service={service} />
            <ServiceConfig device={device} service={service} />
          </div>,
        ])}
      />
    </div>
  );
}

export function ServicesList(p: { device: Device }) {
  return (
    <AsyncView promiseFn={() => apiClient.streamerBox.fetchServices(p.device.id)}>
      {(vp) => (
        <ServicesListP
          data={{
            device: p.device,
            services: vp.data,
          }}
          reload={vp.reload}
        />
      )}
    </AsyncView>
  );
}
